module.exports = __webpack_public_path__ + "img/tele2-tablet_e2310e44c2f7a185c3e0fc3e14466f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2-tablet.jpg
// module id = 254
// module chunks = 0